export default "__VITE_ASSET__20d0e6a7__"